import { render, staticRenderFns } from "./orderReports.vue?vue&type=template&id=30f3fa00"
import script from "./orderReports.vue?vue&type=script&lang=js"
export * from "./orderReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports